/**
 * お問い合わせフォーム 確認画面
 * 「確認する」ボタンで入力値を確認画面に表示し、「送信する」でCF7送信
 */

// CF7 の radio はデフォルトで最初の選択肢がチェックされるため、
// 未選択状態にリセットして JS バリデーションで必須制御する
// checkbox も aria-required を付与して JS バリデーション対象にする
const initRadioRequired = () => {
  document.querySelectorAll('.m-contact-form__radios').forEach((wrapper) => {
    wrapper.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.checked = false;
      radio.setAttribute('aria-required', 'true');
    });
  });

  document
    .querySelectorAll('.m-contact-form__checkboxes')
    .forEach((wrapper) => {
      wrapper.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.setAttribute('aria-required', 'true');
      });
    });
};

const contactFormConfirm = () => {
  initRadioRequired();

  const confirmBtn = document.querySelector('.js-contact-confirm');
  const backBtn = document.querySelector('.js-contact-back');
  const confirmArea = document.querySelector('.js-contact-confirm-area');

  if (!confirmBtn || !backBtn || !confirmArea) return;

  const form = confirmBtn.closest('form');
  if (!form) return;

  const steps = document.querySelectorAll('.m-entry__step');
  const titleEnEl = document.querySelector('.m-page-hero-title__en');
  const titleJaEl = document.querySelector('.m-page-hero-title__ja');

  // -----------------------------------------------
  // 値取得ヘルパー
  // -----------------------------------------------
  const get = (fieldName) =>
    form.querySelector(`[name="${fieldName}"]`)?.value?.trim() ?? '';
  const getCheckedAll = (fieldName) =>
    [...form.querySelectorAll(`[name="${fieldName}"]:checked`)]
      .map((el) => el.value)
      .join('、');

  const set = (selector, text) => {
    const el = confirmArea.querySelector(selector);
    if (el) el.textContent = text;
  };

  const setHtml = (selector, html) => {
    const el = confirmArea.querySelector(selector);
    if (el) el.innerHTML = html;
  };

  // -----------------------------------------------
  // 確認画面へ値を反映
  // -----------------------------------------------
  const populateConfirm = () => {
    set(
      '.js-c-name',
      [get('your-last-name'), get('your-first-name')]
        .filter(Boolean)
        .join('\u3000'),
    );
    set(
      '.js-c-kana',
      [get('your-last-kana'), get('your-first-kana')]
        .filter(Boolean)
        .join('\u3000'),
    );
    set('.js-c-company', get('your-company'));
    set('.js-c-email', get('your-email'));
    set('.js-c-tel', get('your-tel'));
    setHtml('.js-c-message', get('your-message').replace(/\n/g, '<br>'));

    // 案件ごとに追加フィールドをここに記述
  };

  // -----------------------------------------------
  // エラー表示・解除ヘルパー
  // -----------------------------------------------
  const markError = (field, message) => {
    const wrap = field.closest('.wpcf7-form-control-wrap');
    if (!wrap) return;
    wrap.classList.add('is-submitted');
    if (!wrap.querySelector('.wpcf7-not-valid-tip')) {
      const tip = document.createElement('span');
      tip.className = 'wpcf7-not-valid-tip';
      tip.setAttribute('role', 'alert');
      tip.textContent = message;
      wrap.appendChild(tip);
    }
  };

  const clearError = (field) => {
    const wrap = field.closest('.wpcf7-form-control-wrap');
    wrap?.classList.remove('is-submitted');
    wrap?.querySelector('.wpcf7-not-valid-tip')?.remove();
  };

  // -----------------------------------------------
  // バリデーション（全フィールド一括）
  // -----------------------------------------------
  const validate = () => {
    let isValid = true;
    const seenGroupNames = new Set();

    form.querySelectorAll('[aria-required="true"]').forEach((field) => {
      if (field.type === 'radio' || field.type === 'checkbox') {
        const name = field.name;
        if (seenGroupNames.has(name)) return;
        seenGroupNames.add(name);
        if (!form.querySelector(`[name="${name}"]:checked`)) isValid = false;
      } else if (!field.value.trim()) {
        isValid = false;
      }
    });

    const acceptance = form.querySelector('[name="your-privacy"]');
    if (acceptance && !acceptance.checked) {
      isValid = false;
    }

    return isValid;
  };

  const showValidationErrors = () => {
    let firstInvalidWrap = null;

    const seenGroupNames = new Set();

    form.querySelectorAll('[aria-required="true"]').forEach((field) => {
      if (field.type === 'radio' || field.type === 'checkbox') {
        const name = field.name;
        if (seenGroupNames.has(name)) return;
        seenGroupNames.add(name);
        if (!form.querySelector(`[name="${name}"]:checked`)) {
          markError(field, '選択してください。');
          if (!firstInvalidWrap)
            firstInvalidWrap = field.closest('.wpcf7-form-control-wrap');
        } else {
          clearError(field);
        }
      } else if (field.tagName === 'SELECT' && !field.value) {
        markError(field, '選択してください。');
        if (!firstInvalidWrap)
          firstInvalidWrap = field.closest('.wpcf7-form-control-wrap');
      } else if (field.tagName !== 'SELECT' && !field.value.trim()) {
        markError(field, '入力してください。');
        if (!firstInvalidWrap)
          firstInvalidWrap = field.closest('.wpcf7-form-control-wrap');
      } else {
        clearError(field);
      }
    });

    const acceptance = form.querySelector('[name="your-privacy"]');
    if (acceptance) {
      const wrap = acceptance.closest('.wpcf7-form-control-wrap');
      const consentEl = acceptance.closest('.m-contact-form__consent');
      if (!acceptance.checked) {
        wrap?.classList.add('is-submitted');
        if (!firstInvalidWrap) firstInvalidWrap = wrap;
        if (!consentEl?.querySelector('.wpcf7-not-valid-tip')) {
          const tip = document.createElement('span');
          tip.className = 'wpcf7-not-valid-tip';
          tip.setAttribute('role', 'alert');
          tip.textContent = '同意してください';
          consentEl?.appendChild(tip);
        }
      } else {
        wrap?.classList.remove('is-submitted');
        consentEl?.querySelector('.wpcf7-not-valid-tip')?.remove();
      }
    }

    if (firstInvalidWrap) {
      const row =
        firstInvalidWrap.closest('.m-contact-form__row') ?? firstInvalidWrap;
      const headerHeight =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--js-height__header',
          ),
        ) || 0;
      const scrollTop =
        window.scrollY + row.getBoundingClientRect().top - headerHeight - 24;
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }
  };

  // -----------------------------------------------
  // リアルタイムバリデーション（blur / change）
  // -----------------------------------------------
  form.querySelectorAll('[aria-required="true"]').forEach((field) => {
    if (field.type === 'radio' || field.type === 'checkbox') return;

    const eventType = field.tagName === 'SELECT' ? 'change' : 'blur';
    field.addEventListener(eventType, () => {
      if (field.tagName === 'SELECT' && !field.value) {
        markError(field, '選択してください。');
      } else if (field.tagName !== 'SELECT' && !field.value.trim()) {
        markError(field, '入力してください。');
      } else {
        clearError(field);
      }
    });

    if (field.tagName !== 'SELECT') {
      field.addEventListener('input', () => clearError(field));
    }
  });

  // ラジオ・チェックボックス：選択時にエラー解除
  form
    .querySelectorAll('.m-contact-form__radios input[type="radio"]')
    .forEach((radio) => {
      radio.addEventListener('change', () => clearError(radio));
    });

  form
    .querySelectorAll('.m-contact-form__checkboxes input[type="checkbox"]')
    .forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        if (form.querySelector(`[name="${checkbox.name}"]:checked`))
          clearError(checkbox);
      });
    });

  // -----------------------------------------------
  // ステップインジケーター更新（任意）
  // -----------------------------------------------
  const setStep = (index) => {
    steps.forEach((step, i) => {
      step.classList.toggle('m-entry__step--active', i === index);
    });
  };

  // -----------------------------------------------
  // 入力 → 確認
  // -----------------------------------------------
  confirmBtn.addEventListener('click', () => {
    if (!validate()) {
      showValidationErrors();
      return;
    }

    populateConfirm();

    form.querySelector('.m-contact-form')?.setAttribute('hidden', '');
    confirmArea.removeAttribute('hidden');

    if (titleEnEl) titleEnEl.textContent = 'CONFIRM YOUR INQUIRY';
    if (titleJaEl) titleJaEl.textContent = 'お問い合わせ内容の確認';

    setStep(1);

    document
      .querySelector('.m-entry__form-card')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // -----------------------------------------------
  // 確認 → 入力に戻る
  // -----------------------------------------------
  backBtn.addEventListener('click', () => {
    confirmArea.setAttribute('hidden', '');
    form.querySelector('.m-contact-form')?.removeAttribute('hidden');

    if (titleEnEl) titleEnEl.textContent = 'CONTACT';
    if (titleJaEl) titleJaEl.textContent = 'お問い合わせ';

    setStep(0);

    document
      .querySelector('.m-entry__form-card')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // -----------------------------------------------
  // 送信完了後リダイレクト
  // -----------------------------------------------
  document.addEventListener('wpcf7mailsent', () => {
    const thanksUrl =
      window.entryFormConfig?.thanksPageUrl || '/contact/thanks/';
    window.location.href = thanksUrl;
  });

  // -----------------------------------------------
  // CF7 がサーバ側バリデーションで弾いた時：
  // 確認画面なら入力画面に戻して、最初のエラーフィールドまでスクロール
  // ※ .wpcf7-not-valid クラスは wpcf7invalid 発火の「後」に CF7 が付与するため
  //    setTimeout で DOM 反映を待つ（公式 DOM events 推奨パターン）
  // -----------------------------------------------
  document.addEventListener('wpcf7invalid', (event) => {
    // 同一ページ内に複数フォームがあっても誤反応しないよう、event.detail.unitTag で絞る
    const unitTag = event.detail?.unitTag;
    if (unitTag && !form.closest(`#${unitTag}`)) return;

    // 確認画面表示中なら入力画面に戻す（エラー箇所が見えるように）
    if (!confirmArea.hasAttribute('hidden')) {
      confirmArea.setAttribute('hidden', '');
      form.querySelector('.m-contact-form')?.removeAttribute('hidden');
      if (titleEnEl) titleEnEl.textContent = 'CONTACT';
      if (titleJaEl) titleJaEl.textContent = 'お問い合わせ';
      setStep(0);
    }

    setTimeout(() => {
      const firstInvalid =
        form.querySelector('.wpcf7-not-valid') ??
        document.querySelector('.wpcf7-not-valid');
      if (!firstInvalid) return;

      const row =
        firstInvalid.closest('.m-contact-form__row') ??
        firstInvalid.closest('.wpcf7-form-control-wrap') ??
        firstInvalid;
      const headerHeight =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--js-height__header',
          ),
        ) || 0;
      const scrollTop =
        window.scrollY + row.getBoundingClientRect().top - headerHeight - 24;
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }, 100);
  });
};

export { contactFormConfirm };
